export class Identity {
  constructor() {}

  signIn() {
    return Promise.resolve(null);
  }

  signOut() {
    return Promise.resolve(null);
  }

  forgotPassword() {
    return Promise.resolve(null);
  }

  hasForgotPassword() {
    return false;
  }

  mfaSetup() {
    return Promise.resolve(null);
  }

  hasMfaSetup() {
    return false;
  }

  isAuthenticated() {
    return Promise.resolve(false);
  }

  accessToken() {
    return Promise.resolve('');
  }

  idToken() {
    return Promise.resolve('');
  }

  tokens() {
    return Promise.resolve({
      accessToken: '',
      idToken: '',
      refreshToken: '',
    });
  }

  displayName() {
    return Promise.resolve('');
  }

  userInitials() {
    return this.displayName().then((name) => {
      if (!name) return '';

      if (name.includes(' ')) {
        return name
          .split(' ')
          .map((word) => {
            return word[0];
          })
          .join('');
      }
      return name[0];
    });
  }

  getUrlParameter(name: string) {
    //@ts-ignore Not sure how to fix this - This is a question for Mladen since he was working on this
    return new URL(document.location).searchParams.get(name);
  }
}
